import React, { useState } from "react";
import "./OrderPinPopup.scss";
import OTPInput from "../OTP";

const OrderPinPopup = ({ isOpen, onClose, onSubmit }) => {
  const [pin, setPin] = useState("");

  if (!isOpen) return null;

  const submitPin = () => {
    if (pin.length !== 4) {
      alert("Please enter 4-digit PIN");
      return;
    }

    onSubmit(pin);
  };

  return (
    <div className="pin-overlay">
      <div className="pin-box">
        {/* <button className="order-closeBtn round-close-btn" onClick={onClose}>x</button> */}
        <button className="close-btn round-close-btn" onClick={onClose}>
          x
        </button>
        <h3>Enter 4-Digit Order PIN</h3>
        <p className="subtext">This PIN is required to place your order</p>

        <OTPInput
          value={pin}
          onChange={setPin}
          className="pin-input-container"
          inputClassName="pin-input"
          idPrefix="order-pin"
          onComplete={() => document.getElementById('btn-submit-pin')?.focus()}
        />
        <p>
          This PIN is shared with your table and required for the first order.
          Others at your table can use the same PIN to join your session.
        </p>
        <button id='btn-submit-pin' className="submit-btn btn" onClick={submitPin}>
          Submit PIN
        </button>
      </div>
    </div>
  );
};

export default OrderPinPopup;
